// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2QUVq","gfeWrapper":"CalendarEvent_gfeWrapper__3avmZ"};